module.exports = __webpack_public_path__ + "static/media/check-icon-white.3dbb0087.svg";